import { useEffect } from "react"
import { useCouponStore } from "../../store/couponStore"
import CouponFilters from "../../components/Coupon/CouponFilters"
import CouponTable from "../../components/Coupon/CouponTable"
import CouponFormModal from "../../components/Coupon/CouponFormModal"
import CouponExcelPreviewModal from "../../components/Coupon/CouponExcelPreviewModal"

export default function CouponListPage() {
  const fetchCoupons = useCouponStore((s) => s.fetchCoupons)
  const loading = useCouponStore((s) => s.loading)
  const modals = useCouponStore((s) => s.modals)

  useEffect(() => {
    fetchCoupons()
  }, [])

  return (
    <div className="p-6 space-y-6">

      <CouponFilters />

      {loading ? (
        <div>در حال بارگذاری...</div>
      ) : (
        <CouponTable />
      )}

      {modals.formOpen && <CouponFormModal />}
      {modals.excelPreviewOpen && <CouponExcelPreviewModal />}

    </div>
  )
}
